module.exports = __webpack_public_path__ + "static/media/img10.fc022377.jpg";